// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__7yZD5","item":"Pagination_item__1RZv9","selected":"Pagination_selected__jenkv"};